import React from "react";
import NavBar from "../../../components/NavBar/NavBar";
import Footer from "../../../components/Footer/Footer";
import { Banner, BannerText, BannerLogo } from "../../../styles/Banner";
import { Link as RouterLink } from "react-router-dom";
import { Box,Typography, Link,Button,MenuItem,FormControl,} from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import MessageIcon from "@mui/icons-material/Message";

import useSendCashbackFeedback from "../../../hooks/useSendCashbackFeedback";
import { useAlert } from "../../../context/AlertContext";
import CustomTextField from "./CustomTextField";
import NavLinkItem from "../QuemSomos/NavLinksItem";
import { motivos } from "../../../constants/Institucional/fale_conosco";

const Contato = () => {
    const { sendFeedback, loading } = useSendCashbackFeedback();
    const { showAlert } = useAlert();

    const [form, setForm] = React.useState({
        motive: motivos[0],
        name: "",
        email: "",
        title: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validação simples
        if (!form.name || !form.email || !form.title || !form.message) {
        showAlert("Preencha todos os campos", "warning");
        return;
        }

        await sendFeedback(form);
    };

    return (
        <>
        <NavBar />

        <Banner>
            <BannerText>
            <p>
                <a href="https://www.meucupom.com/" target="_blank" rel="noreferrer">
                Home
                </a>{" "}
                &gt; Institucional &gt; Contato
            </p>

            <Box>
                <Typography
                variant="h2"
                sx={{
                    fontSize: { xs: "1.2rem", sm: "2rem" },
                    fontWeight: "bold",
                    textAlign: "center",
                }}
                >
                Contato
                </Typography>
            </Box>

            <Box sx={{ mt: 1 }}>
                <NavLinkItem to="/institucional/quem-somos" label="Quem somos?" />
                <NavLinkItem to="/institucional/imprensa" label="Imprensa" />
                <NavLinkItem to="/institucional/contato" label="Contato" />
            </Box>
            </BannerText>

            <BannerLogo>
            <img
                src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png"
                alt="MeuCupom Logo"
            />
            </BannerLogo>
        </Banner>

        {/* Formulário */}
        <Box component="form" onSubmit={handleSubmit}
            sx={{ maxWidth: { xs: "100%", md: 800 }, mx: "auto", p: { xs: 2, sm: 4 } }}
        >
            <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}>
            Fale conosco
            </Typography>

            <FormControl fullWidth>
            <CustomTextField select label="Motivo do contato" name="motive" value={form.motive} onChange={handleChange} icon={MessageIcon}>
                {motivos.map((item, index) => (
                <MenuItem key={index} value={item}>
                    {item}
                </MenuItem>
                ))}
            </CustomTextField>
            </FormControl>

            <CustomTextField label="Nome" name="name" value={form.name} onChange={handleChange} icon={PersonIcon}/>

            <CustomTextField label="E-mail" name="email" type="email" value={form.email} onChange={handleChange} icon={EmailIcon}/>

            <CustomTextField label="Assunto" name="title" value={form.title} onChange={handleChange} icon={MessageIcon}/>

            <CustomTextField label="Mensagem" name="message" value={form.message} onChange={handleChange} icon={MessageIcon} multiline rows={4}/>

            <Button variant="contained" size="large" type="submit" fullWidth disabled={loading}>
                {loading ? "Enviando..." : "Enviar"}
            </Button>
        </Box>

        <Footer />
        </>
    );
};

export default Contato;